import { createContainer } from '@dbk-legacy/muster/react';

import ExpandableListView from './expandable-list-view';

export default createContainer({
  $fragments: {
    state: {
      expandedItem: true,
      setExpandedItem: { $set: 'expandedItem' },
      expandedItemOffset: true,
      setExpandedItemOffset: { $set: 'expandedItemOffset' },
    },
    uiStatic: {
      detailsGroups: true,
    },
  },
}, ({ state, uiStatic }) => ({
  state,
  detailsGroups: uiStatic.detailsGroups,
}))(ExpandableListView);
